module.exports = __webpack_public_path__ + "static/logo-c5815b9cac21b06a4034dca723583cd7.svg";